<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
const APP_VERSION = process.env.VUE_APP_VERSION || "0.0.0";

export default {
  name: "App",

  async mounted() {
    await this.checkVersion();
  },

  methods: {
    async checkVersion() {
      const storedVersion = localStorage.getItem("app_version");

      // Clear cache if no version stored (first load) or version changed
      if (!storedVersion || storedVersion !== APP_VERSION) {
        await this.clearCacheAndReload();
      }

      // Always update to current version
      localStorage.setItem("app_version", APP_VERSION);
    },

    async clearCacheAndReload() {
      console.log(
        `🚀 Version change detected (${localStorage.getItem(
          "app_version"
        )} → ${APP_VERSION}). Clearing cache...`
      );

      try {
        // 1. Clear storage
        localStorage.clear();
        sessionStorage.clear();

        // 2. Clear IndexedDB
        if (window.indexedDB && window.indexedDB.databases) {
          const databases = await window.indexedDB.databases();
          await Promise.all(
            databases.map((db) => {
              return new Promise((resolve, reject) => {
                const request = window.indexedDB.deleteDatabase(db.name);
                request.onsuccess = resolve;
                request.onerror = reject;
              });
            })
          );
        }

        // 3. Clear caches
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }

        // 4. Unregister service workers
        if ("serviceWorker" in navigator) {
          const registrations =
            await navigator.serviceWorker.getRegistrations();
          await Promise.all(
            registrations.map((registration) => registration.unregister())
          );

          // Additional step: update the service worker immediately
          navigator.serviceWorker.ready.then((registration) => {
            registration.update();
          });
        }

        console.log("✅ Cache cleared successfully");
      } catch (error) {
        console.error("⚠️ Error clearing cache:", error);
      } finally {
        // Force reload after all cleanup
        window.location.href =
          window.location.href.split("?")[0] + "?t=" + Date.now();
      }
    },
  },
};
</script>
